import React from "react";
import { Phone, Star, Clock } from "lucide-react";
import { EMERGENCY_DISPATCH_TIERS } from "@/data/maintenancePlans";

export default function EmergencyDispatchSection() {
  return (
    <section className="section-pad bg-br-black text-white" id="emergency-dispatch" data-testid="emergency-dispatch">
      <div className="container-br">
        <div className="max-w-3xl mb-8">
          <div className="br-eyebrow text-br-bronze-2">Emergency Dispatch</div>
          <h2 className="br-headline text-3xl sm:text-4xl mt-3">Emergency Dispatch & Storm Support</h2>
          <p className="mt-3 text-gray-300 leading-relaxed">
            Active members receive priority access and phone triage when urgent issues come up. Emergency dispatch is available when safe and when scheduling allows. Dispatch fees and hourly rates are separate from the monthly membership unless a specific plan includes a stated emergency credit.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {EMERGENCY_DISPATCH_TIERS.map((tier) => (
            <div
              key={tier.title}
              className={`rounded p-5 border ${tier.highlight ? "bg-br-bronze/10 border-br-bronze" : "bg-br-charcoal border-br-line"}`}
              data-testid={`dispatch-tier-${tier.title.toLowerCase().replace(/[^a-z0-9]+/g,"-")}`}
            >
              <div className="flex items-center gap-2 mb-3">
                {tier.highlight ? <Star size={14} className="text-br-bronze-2" /> : <Phone size={14} className="text-br-bronze-2" />}
                <div className="font-display tracking-widest uppercase text-sm">{tier.title}</div>
              </div>
              {tier.dispatchFee && (
                <div className="text-xl font-bold text-white tabular-nums">{tier.dispatchFee}</div>
              )}
              <div className={`text-sm ${tier.dispatchFee ? "text-gray-300" : "font-bold text-br-bronze-2"} mt-0.5`}>{tier.priceLabel}</div>
              {tier.minimum && (
                <div className="flex items-center gap-1 text-[11px] uppercase tracking-widest text-gray-400 mt-2">
                  <Clock size={11} /> {tier.minimum}
                </div>
              )}
              <p className="text-xs text-gray-400 leading-relaxed mt-3">{tier.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
